import { Input as InputAntd } from 'antd';

import FormField from '../Field';

const TextArea = FormField<string>(InputAntd.TextArea);

export default TextArea;
